<ul id="history-list">
  <ng-template #recursiveList let-navList>
    @for (navElem of navList; track $index) {
      <li>
        <div class="row">
          <mat-icon
            [ngClass]="{ hide: navElem.children?.length === 0 }"
            [svgIcon]="navElem.active ? 'minus-box' : 'plus-box'"
            (click)="navElem.children?.length > 0 && toggle(navElem)"></mat-icon>
          <o-orion-card
            class="item"
            [class.selected-node]="navElem.dmc === dmcSelected"
            [data]="navElem | orionCardFormatter: orionCardSource.NAVIGATION"
            [routerLink]="navElem.dmc | getDUUrl: dmcSelected"
            (click)="navElem.dmc !== dmcSelected && emitClose(navElem)">
          </o-orion-card>
        </div>
        @if (navElem.children?.length > 0) {
          <ul class="nested" [ngClass]="{ active: navElem.active }">
            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: navElem.children }"></ng-container>
          </ul>
        }
      </li>
    }
  </ng-template>

  <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: [navigation] }"></ng-container>
</ul>
